import SetContentsIcon from '@material-ui/icons/TableChart';

import SetContentShow from './SetContentShow';

export default {
  icon: SetContentsIcon,
  show: SetContentShow,
};
